import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2dda0900&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"
import style0 from "./edit.vue?vue&type=style&index=0&id=2dda0900&prod&lang=scss"
import style1 from "./edit.vue?vue&type=style&index=1&id=2dda0900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda0900",
  null
  
)

export default component.exports